// extracted by mini-css-extract-plugin
export default {"ImageRender":"ImageRender_ImageRender__SXBM2"};